import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { NavLink } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { BiEdit, BiTrash } from "react-icons/bi";
import { ToastContainer, toast } from "react-toastify";
import { Button, Modal } from "react-bootstrap";
import Util from "../../Classes/Util";
import { AiOutlineRight } from "react-icons/ai";

const Measurements = () => {
  const [measurements, setmeasurements] = useState();
  const [show, setShow] = useState(0);
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));

  const columns = [
    {
      name: "ID",
      selector: (row) => row.MeasurementId,
    },
    {
      name: "Measurement Value",
      selector: (row) => row.MeasurementValue,
      sortable: true,
      reorder: true,
    },
    {
      name: "Options",
      selector: (row) => (
        <div>
          {permissions.ManageMeasurement && (<NavLink
            to={"/admin/gazelle/Measurements/" + row.MeasurementId}
            className="btn btn-outline-secondary btn-sm"
          >
            <BiEdit />
          </NavLink>)}
          {permissions.DeleteMeasurement && (<button
            className="btn btn-outline-danger btn-sm ms-2"
            onClick={() => setShow(row.MeasurementId)}
          >
            <BiTrash />
          </button>)}
          <Modal show={row.MeasurementId === show} onHide={() => setShow(0)}>
            <Modal.Header>
              <Modal.Title>Delete Request</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="container">
                <div className="row">
                  <p>
                    Are you sure you want to
                    <b> Delete</b> the measurement with the value{" "}
                    <b>{row.MeasurementValue}</b>?
                  </p>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="container">
                <div className="row">
                  <div className="col-8"></div>
                  <div className="col-2">
                    <Button
                      variant="primary"
                      className="form-control"
                      onClick={() => DeleteMeasurement(row.MeasurementId)}
                    >
                      Yes
                    </Button>
                  </div>
                  <div className="col-2">
                    <Button
                      variant="secondary"
                      className="form-control"
                      onClick={() => setShow(0)}
                    >
                      No
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      ),
    },
  ];
  async function DeleteMeasurement(id) {
    let response = await fetch(
      Variables.API_URL + "Measurement/DeleteMeasurement/" + id,
      {
        method: "Delete",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "Access-Control-Allow-Origin": Variables.API_URL,
        },
      }
    );
    let result = await response.json();
    if (response.ok) {
      toast.success(result);
      Getmeasurements();
    } else {
      toast.error(result);
    }
  }

  async function Getmeasurements() {
    const URL = Variables.API_URL + "Measurement/GetMeasurements";
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setmeasurements(listItems);
  }
  //#region Use Effect
  useEffect(() => {
    Getmeasurements();
  }, []);
  //#endregion Use Effect
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>List Measurements</h2>
            <ul className="portalPath">
              <li>Home <AiOutlineRight /></li>
              <li>List Measurements</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="mb-3 text-right">
                  <NavLink to="/admin/gazelle/Measurements/0" className="btn btn-primary">
                    Add Measurement
                  </NavLink>
                </div>
                <div className="portalTable">
                  <DataTable columns={columns} data={measurements} pagination />
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={true}
          newestOnTop={false}
          closeOnClick
        />
      </div>
    </div>
  );
};
export default Measurements;
